import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RequirementExternalElement } from 'api';
import { ExampleComponent } from 'component/details/requirement-intake/requirements-detail/examples/example/example.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'comp-examples',
  templateUrl: './examples.component.html',
  styleUrls: ['./examples.component.scss'],
  imports: [ExampleComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExamplesComponent {
  readonly examples = input.required<Array<RequirementExternalElement>>();
  readonly showHeadline = input<boolean>(true);
}
